import React from 'react';

import FrontPageContent from 'components/frontPage/FrontPageContent';
import SignUpContent from 'components/frontPage/SignUpContent';

function SignUp() {
  return <FrontPageContent rightColumnContent={<SignUpContent />} />;
}
export default SignUp;
